const registerAnimations = () => {

  const $ = window.$;
  function headerNormal(){
    $('.navbar-main').removeClass('bg-transparent');
    $('.navbar-main').addClass('bg-black');	
  }
  function headerTransparent(){
    $('.navbar-main').addClass('bg-transparent');
    $('.navbar-main').removeClass('bg-black');
  }
  
  function msieversion() 
  {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
  
      if (msie > 0) // If Internet Explorer, return version number
      {
          //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
      return true;
      }
      else  // If another browser, return 0
      {
         // alert('otherbrowser');
      return false;
      }
  
      
  }
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  var isEdge = navigator.appVersion.indexOf("Edge");
  
  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var prepare = windowHeight/4;
  
  $(document).ready(function(){
    var windowScroll = $(window).scrollTop();
    var soleFeatures = $('.sole-features-outer').offset().top;
    var sweetingCont = $('.sweetingCont').offset().top;
    var feathers = $('.feathers').offset().top;
    var shoesColorSets = $('.shoes-color-sets').offset().top;
    var footbed = $('.footbed').offset().top;
    
    
    $('.sole-features').addClass('animatable');
    
    if(msieversion() || isIE11 || isEdge != -1){
      $('html').addClass('ie');
    }
    
    
    if(windowScroll >= 50 && $('.header').hasClass('fixed-top')){	
      headerNormal();
    }else{
      headerTransparent();
    }
    if((windowScroll + windowHeight - prepare*2 ) > sweetingCont){
      $('.sweeting img').addClass('fadeInDown');
    }
    
    if((windowScroll + windowHeight - prepare*2 ) > soleFeatures){
      $('.sole-features').addClass('animate'); 
      $('.sole-features-feathers .feather').addClass('fadeInDown');
    }
    
    if((windowScroll + windowHeight - prepare*2 ) > shoesColorSets){
      $('.shoes-color-sets .animatedUp').addClass('fadeInUp');
      $('.shoes-color-sets .animatedDown').addClass('fadeInDown');
    }
    
    if((windowScroll + windowHeight -  prepare*2) > feathers){
      //$('.feathers img').addClass('fallInDown');
      $('.feathers img').addClass('fadeInDown');
    }
    if((windowScroll + windowHeight -  prepare*2) > footbed){
      $('.footbed .animated').addClass('fadeInLeft');
    }
    
    
    $(window).on('scroll', function(){
      if($('#slipper-animation').length){
        var slipper = $('#slipper-animation').offset().top;
         soleFeatures = $('.sole-features-outer').offset().top;
         sweetingCont = $('.sweetingCont').offset().top;
        shoesColorSets = $('.shoes-color-sets').offset().top;	
        footbed = $('.footbed').offset().top;	
        
        var slipperScrollUpTO = 215; 
        if(windowWidth >= 375 && windowWidth < 410){
          slipperScrollUpTO = 250;
        }
        if(windowWidth >= 410 && windowWidth < 480){
          slipperScrollUpTO = 300;
        }
        if(windowWidth >= 480 && windowWidth < 768){
          slipperScrollUpTO = 350;
        }
        if(windowWidth >= 768 && windowWidth < 1200){
          slipperScrollUpTO = 350;
        }
        if(windowWidth >= 1200 && windowWidth < 1440){
          slipperScrollUpTO = 450;
        }
        if(windowWidth >= 1440 && windowWidth < 1600){
          slipperScrollUpTO = 520;
        }
        if(windowWidth >= 1600){
          slipperScrollUpTO = 580;
        }
        }
      windowScroll = $(window).scrollTop();
      //console.log(windowScroll);
      if(windowScroll >= 50 && $('.header').hasClass('fixed-top')){	
        headerNormal();
      }else{
        headerTransparent();
      }
      
      
      var slipperScroll = windowScroll + windowHeight - slipper - prepare;
      if((windowScroll + windowHeight - prepare ) > slipper && slipperScroll > 0){
        //console.log(windowScroll);
        if(slipperScroll <= slipperScrollUpTO){
          $("#layer-inside").css({'transform': 'translateY('+slipperScroll/2.3+'px)',});
          $("#layer-bottom").css({'transform': 'translateY('+slipperScroll/1.6+'px)',});
          $("#layer-base").css({'transform': 'translateY('+slipperScroll/1.3+'px)',});
        }else{
          //console.log("slipperScrollUpTO : " + slipperScrollUpTO + " | slipperScroll : " + slipperScroll);
          
        } 
      }else{
        $("#layer-inside").css({'transform': 'translateY('+0+'px)',});
        $("#layer-bottom").css({'transform': 'translateY('+0+'px)',});
        $("#layer-base").css({'transform': 'translateY('+0+'px)',});
      }
      if((windowScroll + windowHeight - prepare*2 ) > sweetingCont){
        //$('.sweeting img').addClass('fadeInDown');
        $('.sweeting img').addClass('slideInDown');
      }
      if((windowScroll + windowHeight - prepare*2.5 ) > soleFeatures){
        $('.sole-features').addClass('animate');
        $('.sole-features-feathers .feather').addClass('fadeInDown');
      }
      
      if((windowScroll + windowHeight -  prepare*2) > feathers){
        //$('.feathers img').addClass('fallInDown');
        $('.feathers img').addClass('fadeInDown');
      }
      if((windowScroll + windowHeight - prepare*1.25 ) > shoesColorSets){
        $('.shoes-color-sets .animatedUp').addClass('fadeInUp');
        $('.shoes-color-sets .animatedDown').addClass('fadeInDown');
      }
      
      if((windowScroll + windowHeight -  prepare*1.5) > footbed){
        $('.footbed .animated').addClass('fadeInLeft');
      }
  
    });
  
      
    $('.footer h6').on('click', function(){
      if($(window).width() <= 991){
        $(this).closest('section').find('.toggle_content').toggleClass('show');
      }
    });
    
    if($('.alternative_short_text_top_bar').length){
      var alternative_text = $('.alternative_short_text_top_bar').html();
      var alternative_icon = $('.alternative_short_text_top_bar').css('background-image');
      var short_text = $('.topbar_short_text').html();
      //var short_text_icon = $('.topbar_short_text').css('background-image');
      console.log(alternative_icon);
  
    var inst = setInterval(change_short_text, 8000);
  
    function change_short_text() {
    //console.log('change text '+alternative_text+' to '+ short_text);
    $('.topbar_short_text').fadeOut(300,function(){
      $('.topbar_short_text').html(alternative_text);
      $('.topbar_short_text').addClass('alternative_text').fadeIn();
    });
  
    setTimeout(function() {
       $('.topbar_short_text').fadeOut(300,function(){
        $('.topbar_short_text').html(short_text);
        $('.topbar_short_text').removeClass('alternative_text').fadeIn();
      });
    }, 4000);
  
    return 1;
    }
   }
   var totalCount = $(".featured .row .shoe").length;
   $('.featured .shoe').on('mouseover', function(){
     var count = $(this).index();
     //console.log(totalCount + ' current index: '+count);
     if(count + 1 == totalCount){
      $('.featured').addClass('last-child');
     }else{
       $('.featured').removeClass('last-child');
     }
   });
   
   $('.featured').on('mouseout', function(){
     $('.featured').removeClass('last-child');
   });
    
  
    
  });
}

export default registerAnimations;